import { render, staticRenderFns } from "./EndRegistration.vue?vue&type=template&id=ba41ad60"
import script from "./EndRegistration.vue?vue&type=script&lang=js"
export * from "./EndRegistration.vue?vue&type=script&lang=js"
import style0 from "./EndRegistration.vue?vue&type=style&index=0&id=ba41ad60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports